import { sendGoogle } from '../Analytics';
import { BREAKPOINTS } from '../ApplicationConfig';

export default class MainMenu
{
    protected menu: HTMLElement;
    protected toggleItemClass: string; // название класса элементов, которые будут управлять открытием/закрытием меню
    protected isMenuOpened: boolean = false;

    protected classes = {
        toggle: 'menu-mobile',
        
    };

    constructor(menuId: string, toggleItemClass: string)
    {
        this.menu = document.getElementById(menuId) as HTMLElement;
        this.toggleItemClass = toggleItemClass;
        this.isMenuOpened = this.menu.classList.contains(this.classes.toggle);
    }

    public init()
    {
        this.appendEventListeners();
    }

    public show()
    {
        this.menu.classList.add(this.classes.toggle);
        document.body.style.overflow = 'hidden';
        this.isMenuOpened = true;
    }

    public hide()
    {
        this.menu.classList.remove(this.classes.toggle);
        document.body.style.overflow = '';
        this.isMenuOpened = false;
    }

    public switch()
    {
        this.isMenuOpened ? this.hide() : this.show()
    }

    protected appendEventListeners()
    {
        let catalogMenu = this.menu.querySelector('.menu__catalog');
        let menuOverlay = this.menu.querySelector('.menu__overlay');

        catalogMenu.addEventListener('mouseenter', () => {
            menuOverlay.classList.add('menu__overlay_active');
        });
    
        catalogMenu.addEventListener('mouseleave', () => {
            menuOverlay.classList.remove('menu__overlay_active');
        });        

        document.querySelectorAll('.' + this.toggleItemClass).forEach(item => {
            item.addEventListener('click', e => {
                e.stopPropagation();

                this.switch();
                // RAZ-754 - при прокрутке пропадает и появляется меню навигации браузера, меняется высота страницы
                // и становится виден на несколько мгновений тапбар. Скрываем его и показывам вновь
                document.querySelector<HTMLElement>('.tapbar').classList.toggle('display_none');
            });
        });

        // в меню при клике на каталог должно открываться меню каталога из tapbar
        this.menu.querySelectorAll('.js-toggle-catalog-menu-emulate').forEach(item => {
            item.addEventListener('click', e => {
                e.stopPropagation();
                this.switch();

                document.querySelectorAll('.js-toggle-catalog-menu').forEach(button => {
                    let control = button as HTMLElement;
                    // RAZ-754 - при прокрутке пропадает и появляется меню навигации браузера, меняется высота страницы
                    // и становится виден на несколько мгновений тапбар. При нажатии на меню тапбар скрыт, а при клике на
                    // "каталог" в меню должнен открываться список разделов из тапбара. Показываем его
                    document.querySelector<HTMLElement>('.tapbar').classList.remove('display_none');
                    control.click();
                });
            });
        });

        this.menu.querySelectorAll('.js-menu-item').forEach(item => {
            let hoverDelayIn  = null;
            let hoverDelayOut = null;

            item.addEventListener('mouseenter', () => {
                clearTimeout(hoverDelayOut);
                hoverDelayIn = setTimeout(() => {
                    let submenu = item.querySelector('.submenu') as HTMLElement;

                    if (submenu) {
                        submenu.classList.add('submenu_active');

                        if (!item.classList.contains('menu__catalog')) {
                            let menuItem = item as HTMLElement;
                            let submenuRoot = this.menu.querySelector<HTMLElement>('.submenu_root');
                            submenu.style.height = submenuRoot.offsetHeight + 'px';
                            submenu.style.top    = '-' + menuItem.offsetTop + 'px';
                        }
                    }
                }, 100);
            });
        
            item.addEventListener('mouseleave', () => {
                clearTimeout(hoverDelayIn);
                hoverDelayOut = setTimeout(() => {
                    let submenu = item.querySelector('.submenu');
                    if (submenu) {
                        item.querySelector('.submenu').classList.remove('submenu_active');
                    }
                }, 100);
            });
        });
        
        this.menu.querySelectorAll('.menu__link_has-children').forEach(node => {
            let item = node as HTMLElement;

            let hoverDelay = null;
            item.addEventListener('mouseout', () => clearTimeout(hoverDelay));
            item.addEventListener('mouseover', () => {
                hoverDelay = setTimeout(() => sendGoogle('Горизонтальное меню', 'Наведение', item.innerText), 1000);
            });
        });

        this.menu.querySelectorAll('.menu__link, .submenu__item .link').forEach(node => {
            let item = node as HTMLElement;

            item.addEventListener('click', e => {
                if (
                    item.classList.contains('menu__link_has-children')
                    && document.documentElement.clientWidth < BREAKPOINTS.XL
                ) {
                    e.preventDefault();
                } else {
                    sendGoogle('Горизонтальное меню', 'Клик', item.getAttribute('href'));
                }
            });
        });
    }
}
